export default "__VITE_ASSET__U5FrJ587__"